module.exports = __webpack_public_path__ + "img/sonargroup-services.1566a721.jpg";